import { apiClient } from '@/services';
import type { ApiResponse } from '@macroinsight/shared-types';
import { z } from 'zod/v3';

const inviteUserToPrivateBetaDataSchema = z.object({
  email: z.string().email()
});

export type InviteUserToPrivateBetaData = z.infer<typeof inviteUserToPrivateBetaDataSchema>;

export async function inviteUserToPrivateBeta(
  data: InviteUserToPrivateBetaData
): Promise<ApiResponse<any>> {
  const validatedData = inviteUserToPrivateBetaDataSchema.parse(data);

  const response = await apiClient.post<any>('/api/invites/private-beta', validatedData);

  return response;
}
